import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, Content2Xl } from "components/misc/Layouts";
import tw from "twin.macro";
import Header from "./components/headers/light.js";
import { SectionHeading as HeadingBase } from "components/misc/Headings";
import { SectionDescription as DescriptionBase } from "components/misc/Typography";

const Row = tw.div`tw-flex`;
const NavLink = tw.a`tw-mt-4 lg:tw-mt-0 tw-transition tw-duration-300 tw-font-medium tw-pb-1 tw-border-b-2 lg:tw-mr-12 last:tw-mr-0 tw-text-gray-700 tw-border-gray-400 hocus:tw-border-gray-700 `;
const HeroRow = tw(
  Row,
)`tw-max-w-xl tw-flex-col tw-justify-between tw-items-center tw-py-20 lg:tw-py-24 tw-mx-auto`;

const Heading = tw(
  HeadingBase,
)`tw-text-center tw-text-primary-900 tw-leading-snug`;
const Description = tw(
  DescriptionBase,
)`tw-mt-4 tw-text-center lg:tw-text-base tw-text-gray-700 tw-max-w-lg tw-mx-auto lg:tw-mx-0`;

export default () => {
  return (
    <AnimationRevealPage disabled>
      <Header />
      <Container tw="-tw-mx-8 -tw-mt-8 tw-pt-8 tw-px-8">
        <Content2Xl>
          <HeroRow>
            <Heading>This page doesn't seem to exist</Heading>
            <Description tw="tw-mt-12">
              Want to go back to the BAD TRI home page?{" "}
              <NavLink href={"./"}>click here</NavLink>.
            </Description>
          </HeroRow>
        </Content2Xl>
      </Container>
    </AnimationRevealPage>
  );
};
